import type { UserProfile as Profile } from 'oidc-client-ts';

import type { UserProfile } from './loginSlice';

export const mapUserProfile = (profile: Profile): UserProfile => {
    const { family_name: familyName, given_name: givenName, client_id: _clientId, ...rest } = profile;

    return {
        ...rest,
        givenName,
        familyName,
    };
};
